import React from 'react';

import { EmptyStateVariant, EmptyStates } from './constants';

// Components
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

type Props = {
  variant: EmptyStateVariant;
};

const ActionItemsEmptyState = ({ variant }: Props) => {
  const emptyStateContent = EmptyStates[variant];

  return (
    <div className="p-4">
      <EmptyStateContainer
        title={emptyStateContent.title}
        subTitle={emptyStateContent.subtitle}
        image={emptyStateContent.imgSrc}
      />
    </div>
  );
};

export default ActionItemsEmptyState;
